import React from "react";

// react router
import { Link } from 'react-router-dom'

import {
    FooterStylesContainer
} from "./styles/FooterStyles";

// icons
import { FaFacebookSquare, FaTwitterSquare, FaPinterestSquare } from "react-icons/fa";


// compss
import AboutUs from "components/AboutUs";
import ContactUs from "components/ContactUs";

function Theme1Footer() {
    return (
        <>
            <AboutUs />

            <ContactUs />

            <FooterStylesContainer className="footer-container mt-auto">
                <div className="container">
                    <div className="footer-main text-center">
                        {/* social */}
                        <div className="social mb-2 mb-lg-3">
                            <div className="inner d-flex align-items-center justify-content-center">
                                {/* link main */}
                                <a 
                                    href="https://facebook.com/sharer/sharer.php?u=https%3A%2F%2Fkraveglassusa.com%2F" 
                                    target="_blank" 
                                    rel="noreferrer"
                                    className="link-main d-inline-flex align-items-center text-decoration-none text-black mx-2">
                                    <FaFacebookSquare />
                                    <span className="ms-1">Share</span>
                                </a>

                                {/* link main */}
                                <a 
                                    href="https://twitter.com/intent/tweet/?url=https%3A%2F%2Fkraveglassusa.com%2F&text=Krave:" 
                                    target="_blank" 
                                    rel="noreferrer"
                                    className="link-main d-inline-flex align-items-center text-decoration-none text-black mx-2">
                                    <FaTwitterSquare />
                                    <span className="ms-1">Tweet</span>
                                </a>

                                {/* link main */}
                                <a 
                                    href="https://pinterest.com/pin/create/button/?url=https%3A%2F%2Fkraveglassusa.com%2F&description=Krave&media=https%3A%2F%2Fd2j6dbq0eux0bg.cloudfront.net%2Fstartersite%2Fimages%2F38732196%2F1607105720317.jpg" 
                                    target="_blank" 
                                    rel="noreferrer"
                                    className="link-main d-inline-flex align-items-center text-decoration-none text-black mx-2">
                                    <FaPinterestSquare />
                                    <span className="ms-1">Pin</span>
                                </a>
                            </div>
                        </div>

                        {/* links */}
                        <div className="links mb-2 mb-lg-3">
                            {/* link */}
                            <Link to="/content/terms" className="link-main text-decoration-none st-fs-14 text-primary mx-2">
                                Terms and conditions
                            </Link>

                            {/* link */}
                            <Link to="/content/privacy-policy" className="link-main text-decoration-none st-fs-14 text-primary mx-2">
                                Privacy Policy
                            </Link>

                            {/* link */}
                            <Link to="/content/shipping-payment" className="link-main text-decoration-none st-fs-14 text-primary mx-2">
                                Shipping & Payment Info
                            </Link>

                            {/* link */}
                            <Link to="/content/returns" className="link-main text-decoration-none st-fs-14 text-primary mx-2">
                                FAQ
                            </Link>
                        </div>

                        {/* other-info */}
                        <div className="other-info d-flex align-items-center justify-content-center">
                            <p className="mb-0">
                                &copy; Hi Life Tobacco Inc.
                            </p>
                            <span className="mx-2 position-relative" style={{ top: -3 }}>.</span>
                            {/* link */}
                            <Link to="/" className="link-main text-decoration-none st-fs-14 text-primary">
                                Report abuse
                            </Link>
                        </div>
                        
                    </div>
                </div>
            </FooterStylesContainer>
        </>
    );
}
export default Theme1Footer;
